<nav class="navbar navbar-dark navbar-expand-lg bg-body-tertiary" data-bs-theme="dark" style="
direction: ltr; color:white;
">
    <div class="container-fluid">
        <!-- <a class="navbar-brand">
            Navbar
        </a> 
         <div class="d-flex">
            <button class="navbar-toggler me-4" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>


            <ul class="navbar-nav d-flex d-lg-none align-items-center">
                <li class="nav-item dropdown h-100 w-100">
                    <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <span class="d-flex flex-column text-center">
                            <div class="dejaUserPhoto d-flex">
                                <img src class="me-2" alt>
                                <div class="dejaUserDetails d-flex align-items-center">
                                    <div class="me-2">
                                        <p class="h5 mb-1">Ahmed</p>
                                        <p class="h6">Admin</p>
                                    </div>
                                    <i class="fa-solid fa-caret-down ms-2"></i>
                                </div>
                            </div>
                        </span>
                    </a>
                    <ul class="dropdown-menu">
                        <li>
                            <a class="dropdown-item">
                                Action
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item">
                                Another action
                            </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li>
                            <a class="dropdown-item">
                                Something else here
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div> -->

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" type="button" id="dropdownMenuReception" data-toggle="dropdown"
                        aria-expanded="false">
                        <span class="d-flex flex-column text-center">
                            <i class="fa fa-id-card-o" aria-hidden="true"></i>

                            <span>Registeration</span>
                        </span>
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuReception">
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/LaserReservationNewPatient')">
                                New Client
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/laser-client-history')">
                                Client History
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" type="button" id="dropdownMenuReception" data-toggle="dropdown"
                        aria-expanded="false">
                        <span class="d-flex flex-column text-center">
                            <i class="fa-solid fa fa-stethoscope mb-1"></i>
                            <span>Reservation</span>
                        </span>
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuReception">
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/EmrDermaReception')">
                                Reservation
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/LaserReservationNewPatient')">
                                Register Patient
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link  dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">
                        <span class="d-flex flex-column text-center">
                            <i class="fa-solid fa fa-mobile mb-1"></i>
                            <span>Call Center</span>
                        </span>
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/laser-confirmation')">
                                Main Confirmation
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/laser-confirmation-assignment')">
                                 Confirmation Assignment
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/laser-confirmation-reassign')">
                                 Confirmation ReAssignment
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/laser-confirmation-summury')">
                                 Confirmation Summury
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/laser-confirmation-doctor-replacement')">
                                 Confirmation Doctor Replacement
                            </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/laser-follow-up')">
                                Follow Up
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" type="button" id="dropdownMenuReception" data-toggle="dropdown"
                        aria-expanded="false">
                        <span class="d-flex flex-column text-center">
                            <i class="fa-brands fa fa-server mb-1"></i>
                            <span>Service Performing</span>
                        </span>
                    </a>
                    <ul class="dropdown-menu">
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/service-performing')">
                                Service Performing
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item">
                                Service Performing history
                            </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li>
                            <a class="dropdown-item">
                                Something else here
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" type="button" id="dropdownMenuReception" data-toggle="dropdown"
                        aria-expanded="false">
                        <span class="d-flex flex-column text-center">
                            <span style="fill: rgba(255, 255, 255, 0.55);">

                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style=" font-size: 1.8rem;
                                height: 2rem;
                                margin: auto;">
                                    <path
                                        d="M64 0C46.3 0 32 14.3 32 32V96c0 17.7 14.3 32 32 32h80v32H87c-31.6 0-58.5 23.1-63.3 54.4L1.1 364.1C.4 368.8 0 373.6 0 378.4V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V378.4c0-4.8-.4-9.6-1.1-14.4L488.2 214.4C483.5 183.1 456.6 160 425 160H208V128h80c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H64zM96 48H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM64 432c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm48-168a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM160 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM328 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM256 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM424 240a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM352 344a24 24 0 1 1 0-48 24 24 0 1 1 0 48z" />
                                </svg>
                            </span>
                            <span>Cashier</span>
                        </span>
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuReception">
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/LaserSalesOrder')">
                                Sales Order
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/LaserReservationNewPatient')">
                                Register Patient
                            </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li>
                            <a class="dropdown-item">
                                Something else here
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" type="button" id="dropdownMenuReception" data-toggle="dropdown"
                        aria-expanded="false">
                        <span class="d-flex flex-column text-center">
                            <span style="fill: rgba(255, 255, 255, 0.55);">
                                <i class="fa fa-file" aria-hidden="true" style=" font-size: 1.8rem;
                                height: 2rem;
                                margin: auto;"></i>
                            </span>
                            <span>Report</span>
                        </span>
                    </a>
                    <!-- <ul class="dropdown-menu" aria-labelledby="dropdownMenuReception">
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/LaserSalesOrder')">
                                Sales Order
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item" (click)="setRoutLink('laser-derma/LaserReservationNewPatient')">
                                Register Patient
                            </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li>
                            <a class="dropdown-item">
                                Something else here
                            </a>
                        </li>
                    </ul> -->
                </li>
            </ul>
        </div>
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center">
            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle " data-bs-toggle="dropdown" aria-current="page"
                    (click)="setRoutLink('/laser-derma/laser-setup')">
                    <span class="d-flex flex-column text-center">
                        <i class="fa fa-cog  mb-1"></i>
                        <span>Setup</span>
                    </span>
                </a>
            </li>
        </ul>

        <ul class="navbar-nav d-none d-lg-flex align-items-center">
            <li class="nav-item dropdown me-2">
                <a class="nav-link  dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    <span class="d-flex flex-column text-center">
                        <div class="dejaUserPhoto d-none d-lg-flex">
                            <img src class="me-2" alt>
                            <div class="dejaUserDetails d-flex align-items-center">
                                <div class="me-2">
                                    <p class="h5 mb-1">{{userData.userName}}</p>
                                    <!-- <p class="h6">Admin</p> -->
                                </div>
                                <i class="fa-solid fa fa-caret-down ms-2"></i>
                            </div>
                        </div>
                    </span>
                </a>


                <!-- <a class="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <span class="d-flex flex-column text-center">
                        <div class="dejaUserPhoto d-none d-lg-flex">
                            <img src class="me-2" alt>
                            <div class="dejaUserDetails d-flex align-items-center">
                                <div class="me-2">
                                    <p class="h5 mb-1">Ahmed</p>
                                    <p class="h6">Admin</p>
                                </div>
                                <i class="fa-solid fa fa-caret-down ms-2"></i>
                            </div>
                        </div>
                    </span>
                </a> -->
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <li>
                        <a class="dropdown-item">
                            Action
                        </a>
                    </li>
                    <li>
                        <a class="dropdown-item">
                            Another action
                        </a>
                    </li>
                    <li>
                        <hr class="dropdown-divider">
                    </li>
                    <li>
                        <a class="dropdown-item">
                            Something else here
                        </a>
                    </li>
                </ul>
            </li>
        </ul>

        <ul class="navbar-nav me-auto mb-2 mb-lg-0 align-items-center">
            <i style="font-size: 21px;padding: 3px;" class="fa fa-power-off" (click)="logout()"></i>
        </ul>
    </div>
</nav>